// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__+AmXE","checkmark":"Checkbox_checkmark__I0NJm"};